import React, { useReducer, useEffect, useContext } from "react";
import moduleConfig from "./moduleConfig";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";

import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import axios from "../../../config/axios";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";

import CMSFormInput from "../../UI/forms/CMSFormInput";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";

import CMSFormTextArea from "../../UI/forms/CMSFormTextArea";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import {
  createReducer,
  createInitialState,
} from "../../../reducers/module/createReducer";
import { onSubmitGeneral } from "../../../helpers/ModuleHelperFunctions";

const TestimonialCreate = () => {
  const [createState, createDispatch] = useReducer(
    createReducer,
    createInitialState
  );
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  let navigate = useNavigate();

  useEffect(() => {
    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      moduleConfig.breadcrumbs.create,
    ]);
  }, []);

  return (
    <DashboardLayout>
      {createState.status === "fetchFailed" ? (
        <BlockErrorMessage error={createState.error} />
      ) : (
        <>
          {createState.status !== "fetching" && (
            <>
              <ModuleHeader
                moduleTitle={`Create ${moduleConfig.singleItemTitle}`}
                moduleUrl={moduleConfig.url}
              ></ModuleHeader>

              <section className="content">
                <Card>
                  <Card.Body>
                    {createState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    <Formik
                      initialValues={{
                        name: "",
                        image: null,
                        email: "",
                        mobile: "",
                        message: "",
                        sortOrder: "",
                        status: "0",
                      }}
                      validationSchema={yup.object({
                        name: yup.string().required(),
                        message: yup
                          .string()
                          .required()
                          .max(300, "maximum 300 characters allowed"),
                        email: yup.string().email().required(),
                        mobile: yup.string().required(),
                        image: yup
                          .mixed()
                          .nullable()
                          .imageTypeCheck(
                            moduleConfig.imageRequirement.allowedExtensions
                          )
                          .imageSizeCheck(moduleConfig.imageRequirement.size)
                          .imageDimensionCheck(
                            moduleConfig.imageRequirement.dimension
                          ),
                        sortOrder: yup.number().required(),
                        status: yup.string(),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        const formData = new FormData();
                        for (let name in values) {
                          if (Array.isArray(values[name])) {
                            formData.append(name, JSON.stringify(values[name]));
                          } else {
                            formData.append(name, values[name]);
                          }
                        }
                        await onSubmitGeneral(
                          formData,
                          moduleConfig.url,
                          moduleConfig.url,
                          createDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {createState.error && (
                            <FormErrorMessage error={createState.error} />
                          )}

                          <CMSFormInput
                            name="name"
                            label="Full Name"
                            required={true}
                            form={form}
                          />
                           <CMSFormInput
                            name="email"
                            label="Email"
                            required={true}
                            form={form}
                          />
                           <CMSFormInput
                            name="mobile"
                            label="Mobile"
                            required={true}
                            form={form}
                          />

                          <CMSFormImageWithCrop
                            label="Image"
                            name="image"
                            form={form}
                            aspect={1 / 1}
                            outputSize={moduleConfig.imageRequirement.dimension}
                          />
                          <CMSFormTextArea
                            name="message"
                            label="Testimonial"
                            form={form}
                            required={true}
                            maxLength={300}
                          />

                          <CMSFormInput
                            name="sortOrder"
                            label="Sort Order"
                            required={true}
                            form={form}
                          />

                          <CMSFormSelect
                            name="status"
                            label="Status"
                            form={form}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />

                          <button type="submit" className="btn btn-primary ">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default TestimonialCreate;
